export const GLOBALPARAMETER_UPDATE_ACTION_SUCCESS = 'GLOBALPARAMETER_UPDATE_ACTION_SUCCESS';
export const GLOBALPARAMETER_RESET_STATE = 'GLOBALPARAMETER_RESET_STATE';

export function updateGlobalParameter(data) {
  return {
    type: GLOBALPARAMETER_UPDATE_ACTION_SUCCESS,
    data,
  };
}

export function resetGlobalParameterState() {
  return {
    type: GLOBALPARAMETER_RESET_STATE,
  };
}
